// extracted by mini-css-extract-plugin
module.exports = {"milestoneWrapper":"milestone_milestoneWrapper__RAxN0","milestoneBackground":"milestone_milestoneBackground__1kVp_"};